export default __webpack_public_path__ + "static/media/safari.d082229a.png";